import React from 'react';
import { CFooter } from '@coreui/react-pro';

const Footer = () => {
  return (
    <div style={{ position: 'fixed',  bottom: 0, width: '100%', zIndex: 1000 }}>
      <CFooter className="px-4">
        <div>
        
          <span className="ms-1">&copy; 2024 ANSA, All Rights Reserved</span>
        </div>
      
      </CFooter>
    </div>
  );
};

export default React.memo(Footer);